<button class="bell-btn"
        [matMenuTriggerFor]="notifMenu"
        (menuOpened)="onMenuOpened()">
  <mat-icon class="bell-icon"
    [matBadge]="unreadCount > 0 ? (unreadCount > 9 ? '9+' : unreadCount.toString()) : null"
    matBadgeColor="warn"
    matBadgeSize="small"
    [matBadgeHidden]="unreadCount === 0">
    notifications
  </mat-icon>
  <span class="bell-label">{{ 'notifications.title' | translate }}</span>
</button>

<mat-menu #notifMenu="matMenu" class="notif-menu-panel" xPosition="after">

  <div class="notif-header" (click)="$event.stopPropagation()">
    <span class="notif-title">{{ 'notifications.title' | translate }}</span>
    <button *ngIf="unreadCount > 0" mat-button class="mark-all-btn"
            (click)="markAllRead($event)">
      {{ 'notifications.markAllRead' | translate }}
    </button>
  </div>

  <div class="notif-list">
    <ng-container *ngIf="notifications.length > 0; else empty">
      <button *ngFor="let n of notifications"
              mat-menu-item
              class="notif-item"
              [class.unread]="!n.isRead"
              (click)="onItemClick(n)">
        <div class="notif-icon" [style.color]="iconColor(n.type)">
          <mat-icon>{{ n.icon }}</mat-icon>
        </div>
        <div class="notif-body">
          <div class="notif-item-title">{{ n.titleKey | translate }}</div>
          <div class="notif-item-msg">{{ n.messageKey | translate: (n.messageParams || {}) }}</div>
        </div>
        <div class="notif-dot" *ngIf="!n.isRead"></div>
      </button>
    </ng-container>

    <ng-template #empty>
      <div class="notif-empty">
        <mat-icon>check_circle</mat-icon>
        <span>{{ 'notifications.empty' | translate }}</span>
      </div>
    </ng-template>
  </div>

</mat-menu>
